
mutation addSEPADeposit($deposit_reference: String, $amount: String, $tx_reference: String) {
    addSEPADeposit(deposit_reference: $deposit_reference, amount: $amount, tx_reference: $tx_reference) 
}
